var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", { staticClass: "nk-menu-text" }, [
    _c("span", { staticClass: "nk-menu-title" }, [
      _vm._v(_vm._s(_vm.resolvedLabel)),
    ]),
    _vm._v(" "),
    _vm.resolvedSubtext
      ? _c("span", { staticClass: "nk-menu-subtext" }, [
          _vm._v(_vm._s(_vm.resolvedSubtext)),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }